'use client';
import React from 'react';

import { cn } from '@/lib/utils';

import { ContentText } from '@/components/molecules/ContentText';
import Section, { type SectionProps } from '@/components/layout/Section';

import ContactCard from './_components/ContactCard';
import type { ContactSectionConfigType } from './ContactSection.types';

export interface ContactSectionProps extends SectionProps {
    config: ContactSectionConfigType;
}

const ContactSection = React.forwardRef<HTMLDivElement, ContactSectionProps>(
    ({ config, className, ...props }, ref) => {
        const { title, cardsContent, isPopup } = config;

        return (
            <Section
                className={className}
                {...props}
                ref={ref}
            >
                <ContentText
                    title={typeof title === 'string' ? title : undefined}
                    textConfig={Array.isArray(title) ? title : undefined}
                    className="heading-spaces text-center"
                    data-test-id={
                        props['data-test-id'] &&
                        `${props['data-test-id']}-title`
                    }
                />

                <div
                    className={cn(
                        'grid grid-cols-1 gap-6 md:gap-8',
                        !isPopup && 'sm:grid-cols-2',
                    )}
                >
                    {cardsContent.map(card => (
                        <ContactCard
                            key={card.id}
                            config={card}
                        />
                    ))}
                </div>
            </Section>
        );
    },
);

export default ContactSection;
